export const SpaceRecentListApi = Symbol('SpaceRecentListApi');
